<template>
  <div class="p-3">
    <b-form>
      <!-- Identificação -->
      <div class="premium-card shadow-sm mb-4">
        <div class="card-header-premium">
          <i class="fa fa-building mr-2"></i> IDENTIFICAÇÃO DO EMITENTE
        </div>
        <div class="p-3">
          <b-row>
            <b-col md="4">
              <b-form-group label="* CNPJ" label-for="cnpj" class="premium-form-group">
                <b-input-group>
                  <b-form-input id="cnpj" v-model="local.cnpj" :required="true" inputmode="numeric" pattern="\d*" placeholder="00.000.000/0000-00" class="rounded-left-pill" :disabled="!podeEditar" />
                  <b-input-group-append>
                    <b-button variant="outline-primary" class="rounded-right-pill" @click.prevent="onCnpjLookup" :disabled="!podeEditar">
                      <i class="fa fa-search"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col md="5">
              <b-form-group label="* Razão Social" label-for="razao" class="premium-form-group">
                <b-form-input id="razao" v-model="local.razaoSocial" :required="true" class="rounded-pill bg-light" :readonly="readonlyFields.razaoSocial" />
              </b-form-group>
            </b-col>

            <b-col md="3">
              <b-form-group label="Nome Fantasia" label-for="fantasia" class="premium-form-group">
                <b-form-input id="fantasia" v-model="local.nome" class="rounded-pill bg-light" :readonly="readonlyFields.nome" />
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="3">
              <b-form-group label="* Inscrição Estadual" label-for="ie" class="premium-form-group">
                <b-form-input id="ie" v-model="local.ie" :required="true" class="rounded-pill" :disabled="!podeEditar" />
              </b-form-group>
            </b-col>

            <b-col md="3">
              <b-form-group label="Insc. Est. Subst. Tributário" label-for="iest" class="premium-form-group">
                <b-form-input id="iest" v-model="local.ieSt" class="rounded-pill" :disabled="!podeEditar" />
              </b-form-group>
            </b-col>

            <b-col md="3">
              <b-form-group label="Inscrição Municipal" label-for="im" class="premium-form-group">
                <b-form-input id="im" v-model="local.im" class="rounded-pill" :disabled="!podeEditar" />
              </b-form-group>
            </b-col>

            <b-col md="3">
              <b-form-group label="CNAE" label-for="cnae" class="premium-form-group">
                <b-form-input id="cnae" v-model="local.cnae" class="rounded-pill" :disabled="!podeEditar" />
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </div>

      <!-- Endereço -->
      <div class="premium-card shadow-sm mb-4">
        <div class="card-header-premium">
          <i class="fa fa-map-marker mr-2"></i> ENDEREÇO DO EMITENTE
        </div>
        <div class="p-3">
          <b-row>
            <b-col md="6">
              <b-form-group label="Logradouro" label-for="logradouro" class="premium-form-group">
                <b-form-input id="logradouro" v-model="local.endereco.logradouro" class="rounded-pill bg-light" :readonly="readonlyFields.logradouro" />
              </b-form-group>
            </b-col>

            <b-col md="2">
              <b-form-group label="Número" label-for="numero" class="premium-form-group">
                <b-form-input id="numero" v-model="local.endereco.numero" class="rounded-pill bg-light" :readonly="readonlyFields.numero" />
              </b-form-group>
            </b-col>

            <b-col md="4">
              <b-form-group label="Complemento" label-for="complemento" class="premium-form-group">
                <b-form-input id="complemento" v-model="local.endereco.complemento" class="rounded-pill" :disabled="!podeEditar" />
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="3">
              <b-form-group label="Bairro" label-for="bairro" class="premium-form-group">
                <b-form-input id="bairro" v-model="local.endereco.bairro" class="rounded-pill bg-light" :readonly="readonlyFields.bairro" />
              </b-form-group>
            </b-col>

            <b-col md="2">
              <b-form-group label="País" label-for="pais" class="premium-form-group">
                <b-form-input id="pais" v-model="local.endereco.pais" class="rounded-pill bg-light" readonly />
              </b-form-group>
            </b-col>

            <b-col md="2">
              <b-form-group label="UF" label-for="uf" class="premium-form-group">
                <b-form-input id="uf" v-model="local.endereco.uf" class="rounded-pill bg-light" readonly />
              </b-form-group>
            </b-col>

            <b-col md="3">
              <b-form-group label="Município" label-for="municipio" class="premium-form-group">
                <b-input-group>
                  <b-form-input id="municipio" v-model="local.endereco.municipio" class="rounded-left-pill bg-light" readonly />
                  <b-input-group-append>
                    <b-button variant="outline-primary" class="rounded-right-pill" @click.prevent="onMunicipioLookup" :disabled="!podeEditar">
                      <i class="fa fa-search"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col md="2">
              <b-form-group label="CEP" label-for="cep" class="premium-form-group">
                <b-form-input id="cep" v-model="local.endereco.cep" inputmode="numeric" pattern="\d*" placeholder="00000-000" class="rounded-pill" :disabled="!podeEditar" />
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="3">
              <b-form-group label="Fone" label-for="fone" class="premium-form-group mb-0">
                <b-form-input id="fone" v-model="local.endereco.fone" inputmode="tel" placeholder="(00) 0000-0000" class="rounded-pill" :disabled="!podeEditar" />
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-form>

    <!-- Modal de Pesquisa de Empresa -->
    <b-modal
      id="modal-pesquisa-empresa"
      header-class="p-0"
      modal-class="premium-modal"
      size="lg"
      ok-only
      ok-title="Fechar"
      @show="carregarEmpresas"
    >
      <template #modal-header>
        <div class="bg-gradient-primary w-100 p-3 d-flex align-items-center justify-content-between">
          <h5 class="modal-title text-white m-0">
            <i class="fa fa-search mr-2"></i>
            Pesquisar Empresa
          </h5>
          <button type="button" class="close text-white" @click="$bvModal.hide('modal-pesquisa-empresa')">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </template>

      <div class="p-3">
        <b-form-group label="Pesquisar" label-for="pesquisa-empresa" class="premium-form-group">
          <b-form-input
            id="pesquisa-empresa"
            v-model="empresaPesquisa"
            placeholder="Digite para filtrar empresas..."
            class="rounded-pill"
          />
        </b-form-group>

        <b-table
          class="premium-table"
          :items="empresasFiltradas"
          :fields="empresaFields"
          small
          striped
          hover
          responsive
        >
          <template #cell(actions)="data">
            <b-button variant="primary" class="rounded-pill px-3" @click="selecionarEmpresa(data.item)">
              Selecionar
            </b-button>
          </template>
        </b-table>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'NfeAbaEmitente',
  props: {
    nfe: { type: Object, required: true },
    podeEditar: { type: Boolean, default: false }
  },
  data() {
    return {
      // local copy so we don't mutate prop directly
      local: this.initialLocal(),
      // options placeholders
      ufOptions: [/* TODO: load from store (CDSUFNFE) */],
      paisOptions: [/* TODO: load from store or DFM */],
      // readonly fields according to DFM Properties.ReadOnly flags
      readonlyFields: {
        razaoSocial: true, // DFM: EdTX_RAZAO_SOCIAL_EMIT.Properties.ReadOnly = True
        nome: true, // TX_NOME_FANTASIA_EMIT readOnly in DFM
        logradouro: true,
        numero: true,
        bairro: true
      },
      empresas: [],
      empresaPesquisa: '',
      empresaFields: [
        { key: 'CODIGO', label: 'Código', sortable: true },
        { key: 'APELIDO', label: 'Apelido', sortable: true },
        { key: 'RAZAO', label: 'Razão Social', sortable: true },
        { key: 'IE', label: 'IE', sortable: true },
        { key: 'actions', label: '', class: 'text-right' }
      ]
    }
  },
  computed: {
    empresasFiltradas() {
      if (!this.empresaPesquisa) return this.empresas
      const search = this.empresaPesquisa.toLowerCase()
      return this.empresas.filter(emp => 
        (emp.APELIDO || '').toLowerCase().includes(search) ||
        (emp.RAZAO || '').toLowerCase().includes(search) ||
        (emp.IE || '').toLowerCase().includes(search) ||
        String(emp.CODIGO || '').includes(search)
      )
    }
  },
  watch: {
    // Watch specific nfe.ID changes to reload emitente data
    'nfe.ID': {
      handler(newId, oldId) {
        if (newId && newId !== oldId) {
          this.local = this.initialLocal()
          this.carregarNomeMunicipio()
        }
      },
      immediate: true
    },
    // Watch municipioId changes specifically
    'local.endereco.municipioId': {
      handler(newVal, oldVal) {
        if (newVal && newVal !== oldVal) {
          this.carregarNomeMunicipio()
        }
      }
    },
    // when local emitente changes, emit merged object upward
    local: {
      handler() { this.emitInput() },
      deep: true
    }
  },
  created() {
    this.local = this.initialLocal()
  },
  mounted() {
    this.carregarNomeMunicipio()
  },
  methods: {
    initialLocal() {
      // Usar campos MAIÚSCULOS diretos do nfe
      const n = this.nfe || {}
      return {
        nome: n.TX_NOME_FANTASIA_EMIT || '',
        razaoSocial: n.TX_RAZAO_SOCIAL_EMIT || '',
        cnpj: n.TX_NUM_CNPJ_EMIT || '',
        ie: n.TX_NUM_IE_EMIT || '',
        ieSt: n.TX_NUM_IE_SUBST_EMIT || '',
        im: n.TX_NUM_IM_EMIT || '',
        cnae: n.TX_CNAE_EMIT || '',
        endereco: {
          logradouro: n.TX_LOGRADOURO_EMIT || '',
          numero: n.TX_NUMERO_EMIT || '',
          complemento: n.TX_COMPLEMENTO_EMIT || '',
          bairro: n.TX_BAIRRO_EMIT || '',
          pais: n.TX_PAIS_EMIT || 'BRASIL',
          uf: n.ID_UF_EMIT || '',
          municipio: n.MUNICIPIO_NOME_EMIT || n.ID_MUNICIPIO_EMIT || '',
          municipioId: n.ID_MUNICIPIO_EMIT || '',
          cep: n.TX_CEP_EMIT || '',
          fone: n.TX_FONE_EMIT || ''
        }
      }
    },
    emitInput() {
      // Atualizar campos MAIÚSCULOS diretamente no nfe
      const merged = Object.assign({}, this.nfe || {}, {
        TX_NOME_FANTASIA_EMIT: this.local.nome,
        TX_RAZAO_SOCIAL_EMIT: this.local.razaoSocial,
        TX_NUM_CNPJ_EMIT: this.local.cnpj,
        TX_NUM_IE_EMIT: this.local.ie,
        TX_NUM_IE_SUBST_EMIT: this.local.ieSt,
        TX_NUM_IM_EMIT: this.local.im,
        TX_CNAE_EMIT: this.local.cnae,
        TX_LOGRADOURO_EMIT: this.local.endereco.logradouro,
        TX_NUMERO_EMIT: this.local.endereco.numero,
        TX_COMPLEMENTO_EMIT: this.local.endereco.complemento,
        TX_BAIRRO_EMIT: this.local.endereco.bairro,
        TX_PAIS_EMIT: this.local.endereco.pais,
        ID_UF_EMIT: this.local.endereco.uf,
        ID_MUNICIPIO_EMIT: this.local.endereco.municipioId,
        MUNICIPIO_NOME_EMIT: this.local.endereco.municipio,
        TX_CEP_EMIT: this.local.endereco.cep,
        TX_FONE_EMIT: this.local.endereco.fone
      })
      
      this.$emit('input', merged)
    },
    onCnpjLookup() {
      this.$bvModal.show('modal-pesquisa-empresa')
    },
    onMunicipioLookup() {
      // origem: contexto/units delphi/Unt_NotaFiscalEletronica.dfm: ComboID_MUNICIPIO_ENT (lookup)
      // TODO: implement municipio lookup and set local.endereco.municipio and local.endereco.uf
      this.$emit('open-municipio-lookup')
    },

    async carregarNomeMunicipio() {
      const municipioId = this.local.endereco.municipioId
      
      // Se já tem o nome do município ou não tem ID, não precisa buscar
      if (!municipioId || (this.local.endereco.municipio && isNaN(this.local.endereco.municipio))) {
        return
      }

      try {
        const { data } = await this.$http.get(`/api/protected/municipios/getById/${municipioId}`)
        const municipio = Array.isArray(data) ? data[0] : data
        
        if (municipio && municipio.NOME) {
          this.local.endereco.municipio = municipio.NOME
        }
      } catch (err) {
        console.error('Erro ao carregar município:', err)
      }
    },
    async carregarEmpresas() {
      try {
        const { data } = await this.$http.get('/api/protected/empresa/getTodas')
        this.empresas = data || []
      } catch (err) {
        console.error('Erro ao carregar empresas:', err)
        this.empresas = []
      }
    },
    async selecionarEmpresa(empresa) {
      try {
        // Buscar dados completos da empresa
        const { data } = await this.$http.get(`/api/protected/empresa/getById/${empresa.CODIGO}`)
        const emp = Array.isArray(data) ? data[0] : data
        
        if (emp) {
          // Atualizar ID_EMPRESA no nfe para disparar watcher em outros componentes (ex: carregar séries)
          this.$set(this.nfe, 'ID_EMPRESA', emp.CODIGO)
          
          // Preencher dados da empresa no emitente
          this.local.cnpj = emp.CNPJ || ''
          this.local.razaoSocial = emp.RAZAO || ''
          this.local.nome = emp.APELIDO || ''
          this.local.ie = emp.IE || ''
          this.local.ieSt = emp.IE_ST || ''
          this.local.im = emp.IM || ''
          this.local.cnae = emp.CNAE || ''
          
          // Preencher endereço
          this.local.endereco.logradouro = emp.ENDERECO || ''
          this.local.endereco.numero = emp.NUMERO || ''
          this.local.endereco.complemento = emp.COMPLEMENTO || ''
          this.local.endereco.bairro = emp.BAIRRO || ''
          this.local.endereco.cep = emp.CEP || ''
          this.local.endereco.uf = emp.ID_UF || ''
          this.local.endereco.municipioId = emp.ID_MUNICIPIO || ''
          this.local.endereco.fone = emp.FONE || ''
          this.local.endereco.pais = 'BRASIL'
          
          // Carregar nome do município
          await this.carregarNomeMunicipio()
          
          this.$bvModal.hide('modal-pesquisa-empresa')
          this.empresaPesquisa = ''
        }
      } catch (err) {
        console.error('Erro ao carregar dados da empresa:', err)
      }
    }
  }
}
</script>

<style scoped>
/* keep project visual consistency; no custom styles necessary now */
</style>



// WEBPACK FOOTER //
// src/views/faturamento/nfe/partials/NfeAbaEmitente.vue